


























import { Vue, Component, Prop } from 'vue-property-decorator';
import { ReportDTO, ReportAndFile } from '../../../src_server/entity/dto/ReportDTO';
import { dayjs, DT_FORMAT_JA } from '../../../src_server/common/momentExtends';
import { LessonStates } from '../../../src_server/entity/master/LessonStates';
import VueLazyload from 'vue-lazyload';
import { DailyReportService } from '../../biz/remote/DailyReportService';
import { MessageDialog } from '../../utils/MessageDialog';
import { Session } from '../../utils/Session';

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '/assets/ui/attach_file.png',
  loading: '/assets/logos/logo.svg',
  attempt: 2,
  throttleWait: 300,
});
@Component({
  components: {},
  filters: {
    dateFormat: (dt: Date) => {
      return dayjs(dt).format(DT_FORMAT_JA);
    },
  },
})
export default class CommentAndFilePanel extends Vue {
  @Prop()
  private dto!: ReportDTO;

  get isEditMode() {
    return this.dto.lessons.reservation_state !== LessonStates.ALREADY;
  }

  async deleteComment(report_comment_id: number) {
    // alert(report_comment_id);
    const isOK = await MessageDialog.confirm(`コメントを削除してよろしいですか？`);
    if (isOK) {
      const biz = new DailyReportService();
      await biz.deleteComment(report_comment_id);
      await MessageDialog.alert(`削除しました`);
      this.dto.comments = this.dto.comments.filter((i) => i.report_comment_id !== report_comment_id);
    }
  }

  get commentAndFile() {
    console.log(this.dto);
    return this.dto.comments.map((com) => {
      // 添付ファイルが一致するコメントを探す
      const attacheFile = this.dto.attaches.filter((v) => {
        return v.report_comment_id === com.report_comment_id;
      });

      // ファイルURL文字列を返却オブジェクトにセット
      console.log(com);
      const data: ReportAndFile = Object.create(com);
      data.report_comment_id = com.report_comment_id!;

      // データに自分のコメントを付加
      (data as any).isMyComment = com.user_id === Session.getSessionUserId();
      data.urls = attacheFile.map((f) => f.url || '');
      return data;
    });
  }
}
